<div id="static-page">
  @if (page) {
    <h1>{{ page.heading }}</h1>
    <table>
    @for (link of page.links; track $index) {
      <tr>
        <td><a [href]="link.url" class="p-button primary p-2" target="_blank">{{  link.title }}</a></td>
        <td class="pl-2">{{ link.description }}</td>
      </tr>
    }
    </table>
  }
</div>
